import { render, staticRenderFns } from "./comp_Hook-Footer-Top-Certificates.vue?vue&type=template&id=67439b88&"
import script from "./comp_Hook-Footer-Top-Certificates.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-Footer-Top-Certificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
